(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["melandi-cart-reservation"] && !Shopify.designMode) return;
  try {
    (() => {
  if(customElements.get('melandi-cart-reservation'))return;
  const key='melandi_cart_countdown_15m_open_v3_until',duration=900000;
  let memoryDeadline=0;
  const deadline=()=>{
    let until=memoryDeadline;
    try{until=Number(sessionStorage.getItem(key))||until;}catch{}
    if(!Number.isFinite(until)||until<=Date.now()){
      until=Date.now()+duration;
      try{sessionStorage.setItem(key,String(until));}catch{}
    }
    memoryDeadline=until;
    return until;
  };
  customElements.define('melandi-cart-reservation',class extends HTMLElement{
    connectedCallback(){
      this.clock=this.querySelector('.melandi-cart-reservation__time');
      this.hidden=Number(this.dataset.itemCount)<1;
      if(this.hidden)return;
      this.drawer=this.closest('cart-drawer');
      this.observer=new MutationObserver(()=>this.tick());
      if(this.drawer)this.observer.observe(this.drawer,{attributes:true,attributeFilter:['class']});
      this.tick();
      this.interval=setInterval(()=>this.tick(),1000);
      this.onVisibility=()=>this.tick();
      document.addEventListener('visibilitychange',this.onVisibility);
    }
    disconnectedCallback(){
      clearInterval(this.interval);
      if(this.observer)this.observer.disconnect();
      if(this.onVisibility)document.removeEventListener('visibilitychange',this.onVisibility);
    }
    tick(){
      let saved=memoryDeadline;
      try{saved=Number(sessionStorage.getItem(key))||saved;}catch{}
      this.drawer=this.closest('cart-drawer');
      if(!saved && (!this.drawer || !this.drawer.classList.contains('active')))return;
      const remaining=Math.ceil(Math.max(0,deadline()-Date.now())/1000)*1000;
      const minutes=Math.floor(remaining/60000),seconds=Math.floor(remaining/1000)%60;
      if(this.clock)this.clock.textContent=minutes+':'+String(seconds).padStart(2,'0');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["melandi-review-cards"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('melandi-review-cards'))customElements.define('melandi-review-cards',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const v=this.querySelector('.melandi-review-cards__viewport'),prev=this.querySelector('.melandi-review-cards__prev'),next=this.querySelector('.melandi-review-cards__next');const update=()=>{prev.disabled=v.scrollLeft<2;next.disabled=v.scrollLeft>=v.scrollWidth-v.clientWidth-2};prev.addEventListener('click',()=>v.scrollBy({left:-(v.firstElementChild.offsetWidth+16)}));next.addEventListener('click',()=>v.scrollBy({left:v.firstElementChild.offsetWidth+16}));v.addEventListener('scroll',update,{passive:true});this.observer=new ResizeObserver(update);this.observer.observe(v);update()}
disconnectedCallback(){this.observer?.disconnect();this.ready=false}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["melandi-shipping-bar"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('melandi-shipping-bar')){
    customElements.define('melandi-shipping-bar',class extends HTMLElement{
      connectedCallback(){
        this.updateDate();
        this.timer=setInterval(()=>this.updateDate(),60000);
        this.availabilityController=new AbortController();
        const container=this.closest('.product__info-container');
        container?.addEventListener('change',event=>{
          const picker=event.target.closest('variant-selects, variant-radios');
          if(picker && 'currentVariant' in picker){
            this.hidden=!picker.currentVariant?.available;
          }
        },{signal:this.availabilityController.signal});
      }
      disconnectedCallback(){clearInterval(this.timer);this.availabilityController?.abort();}
      updateDate(){
        const target=this.querySelector('time');if(!target)return;
        const date=new Date();
        let remaining=Math.min(14,Math.max(0,Math.trunc(Number(this.dataset.days)||0)));
        while(remaining>0){date.setDate(date.getDate()+1);if(this.dataset.weekdays!=='true'||![0,6].includes(date.getDay()))remaining--;}
        target.dateTime=[date.getFullYear(),String(date.getMonth()+1).padStart(2,'0'),String(date.getDate()).padStart(2,'0')].join('-');
        const text=date.toLocaleDateString('fr-FR',{weekday:'short',month:'long',day:'numeric'});
        target.textContent=text.replace(/(^|\s)([a-zàâäéèêëïîôöùûüÿœç])/g,(_,space,letter)=>space+letter.toUpperCase());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
